import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadEolo = () => {
    const promiseEolo = new Promise((resolve, reject) => {
        loader.load(
            "office/model/eolo/eolo.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                // Posizione iniziale sulla scrivania (da regolare)
                model.position.set(-0.6595305363199475, 1.697502913475706, 4.6852032573976246);
                model.scale.set(0.12, 0.12, 0.12);
                model.rotation.set(0, 1.1180725387469852, 0);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                //Abilitiamo il ControlFunction per posizionarlo con il mouse
                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseEolo;
};

export { loadEolo };
